var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheildicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.377 41.8455C64.377 57.94 53.1109 65.9872 39.7203 70.6546C39.0191 70.8922 38.2574 70.8808 37.5636 70.6224C24.1409 65.9872 12.8748 57.94 12.8748 41.8455V19.3133C12.8748 18.4596 13.2139 17.6408 13.8175 17.0372C14.4212 16.4335 15.2399 16.0944 16.0936 16.0944C22.5314 16.0944 30.5786 12.2317 36.1795 7.33902C36.8615 6.75639 37.7289 6.43628 38.6259 6.43628C39.5228 6.43628 40.3903 6.75639 41.0722 7.33902C46.7053 12.2639 54.7203 16.0944 61.1581 16.0944C62.0118 16.0944 62.8305 16.4335 63.4342 17.0372C64.0379 17.6408 64.377 18.4596 64.377 19.3133V41.8455Z",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheildicon);
export default __webpack_public_path__ + "static/media/sheild icon.8e72599f9ef5ffcf7f66352ac6a47614.svg";
export { ForwardRef as ReactComponent };